/* The featured strip's rules, kept in step with backend/featured_strip.py so the
   form can say what's wrong before the save round-trip. The server re-checks. */
export const TEXT_MAX = 70;

/* The site path a page is served at. Page ids store nested slugs with %2F. */
export const pagePath = (page) => {
  const slug = decodeURIComponent(page?.slug || page?.id || '').replace(/^\/+|\/+$/g, '');
  return slug ? `/${slug}/` : '/';
};

/* Reduce a pasted URL on this site to its path; anything else is returned as typed. */
export const toPath = (link, host) => {
  const value = (link || '').trim();
  const m = value.match(/^https?:\/\/([^/?#]+)(\/[^?#]*)?/i);
  if (!m) return value;
  const bare = (h) => (h || '').toLowerCase().replace(/^www\./, '');
  return bare(m[1]) === bare(host) ? (m[2] || '/') : value;
};

/* The first problem with the form, or null when it can be saved. */
export const stripProblem = (text, link) => {
  const t = (text || '').replace(/\s+/g, ' ').trim();
  if (!t) return 'Write a short message.';
  if (t.length > TEXT_MAX) return `Keep the message to ${TEXT_MAX} characters so it fits on one line (now ${t.length}).`;
  const l = (link || '').trim();
  if (!l) return 'Pick the page to link to.';
  if (/^https?:\/\//i.test(l)) return 'Link must be a page on this site.';
  if (!l.startsWith('/') || l.startsWith('//')) return 'Link must be a path on this site, like /my-page/.';
  if (/\s/.test(l)) return "Link can't contain spaces.";
  return null;
};

/* Pages worth offering in the picker: published ones, titles first, A-Z. */
export const pickablePages = (pages) =>
  (pages || [])
    .filter((p) => !p.status || p.status === 'published')
    .sort((a, b) => (a.title || a.slug || '').localeCompare(b.title || b.slug || ''));
